import {PropertyList} from 'components';
import {EnableSmsMFA} from 'components/EnableSmsMFA';
import {useUserContext} from 'hooks/useUserContext';
import {formatPhone} from 'lib/formaters';
import React from 'react';

export const GeneralSettings: React.FC = () => {
  const user = useUserContext();
  return (
    <>
      <h2>Profile</h2>
      <PropertyList
        style={{marginBottom: 30}}
        properties={[
          {
            label: 'Name',
            value: user.userName
          },
          {
            label: 'Email',
            value: user.userEmail
          },
          {label: 'Phone number', value: formatPhone(user.userPhone)}
        ]}
      />
      <h3>Two-step authentication</h3>
      <p>Keep your account extra secure with a second authentication step.</p>
      <EnableSmsMFA />
    </>
  );
};
